import cx from "classnames";

import { SelectableCardProps, SelectableCard } from "./SelectableCard";

type StorageCardExtraProps = { label: string };

type StorageCardProps = StorageCardExtraProps & SelectableCardProps;

export const StorageCard = ({
  label,
  className,
  ...props
}: StorageCardProps) => (
  <SelectableCard
    className={cx("w-100 h-14 text-lg font-medium", className)}
    {...props}
  >
    <div className={cx(props.isDisabled && "opacity-50")}>{label}</div>
  </SelectableCard>
);
